export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-line' },
  { slug: 'bl', name: '耽美', icon: 'ri-genderless-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
];

export const comics = [
  {
    id: 1,
    title: '恶女的审判',
    titleKo: '악녀의 심판',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20cover%20art%20featuring%20an%20elegant%20woman%20in%20royal%20court%20attire%20with%20dramatic%20lighting%20and%20emotive%20expression%2C%20intricate%20jewelry%20details%2C%20soft%20watercolor%20texture%20background%20in%20warm%20peach%20and%20rose%20tones%2C%20romance%20webtoon%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    author: '李智慧',
    category: 'romance',
    status: '连载中',
    rating: 9.5,
    description: '被诬陷为恶女的大小姐，在审判中觉醒前世记忆。她决定不再忍气吞声，用智慧和计谋揭开真相，让真正的恶人得到应有的惩罚。一场精彩绝伦的复仇与救赎就此展开。',
    chapters: 48,
    updateTime: '2026-08-04',
    views: 1280000,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 2,
    title: '剑与魔法',
    titleKo: '검과마법',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20featuring%20a%20young%20warrior%20wielding%20a%20glowing%20magical%20sword%20with%20ethereal%20blue%20energy%20effects%2C%20fantasy%20adventure%20style%2C%20dramatic%20pose%2C%20mystical%20forest%20background%20with%20soft%20warm%20light%20beams%2C%20clean%20art%20style%2C%20webtoon%20cover%20design&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    author: '朴俊秀',
    category: 'fantasy',
    status: '连载中',
    rating: 9.3,
    description: '在一个魔法与剑术并存的世界，平凡少年意外获得传说中的圣剑。他踏上了拯救王国的冒险之旅，途中结识了各色伙伴，共同对抗黑暗势力的入侵。',
    chapters: 72,
    updateTime: '2026-08-03',
    views: 980000,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 3,
    title: '暗夜追踪者',
    titleKo: '나이트트래커',
    cover: 'https://readdy.ai/api/search-image?query=A%20noir%20style%20Korean%20manhwa%20cover%20showing%20a%20detective%20in%20a%20dark%20alleyway%20with%20moody%20atmospheric%20lighting%2C%20rain%2C%20mysterious%20silhouette%2C%20thriller%20genre%20artwork%2C%20deep%20shadows%20and%20warm%20street%20lamp%20glow%2C%20clean%20webtoon%20cover%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    author: '金泰亨',
    category: 'thriller',
    status: '已完结',
    rating: 9.7,
    description: '首尔夜晚的街头接连发生离奇案件，天才侦探崔民秀通过蛛丝马迹追踪连环杀手。每一个案件背后都隐藏着令人震撼的真相，紧张刺激的推理故事让你欲罢不能。',
    chapters: 86,
    updateTime: '2026-07-20',
    views: 1560000,
    isHot: false,
    isFeatured: true,
  },
  {
    id: 4,
    title: '校园狂想曲',
    titleKo: '스쿨랩소디',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20Korean%20manhwa%20cover%20featuring%20cheerful%20high%20school%20students%20in%20uniforms%20laughing%20together%2C%20comedy%20slice-of-life%20style%2C%20bright%20sunny%20school%20courtyard%20background%2C%20playful%20expressions%2C%20warm%20and%20lively%20atmosphere%2C%20clean%20webtoon%20art&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    author: '郑恩地',
    category: 'comedy',
    status: '连载中',
    rating: 9.1,
    description: '一群性格迥异的高中生在日常校园生活中发生的爆笑故事。从课堂恶作剧到社团活动的种种乌龙，每个角色都有着让人捧腹大笑的独特魅力。',
    chapters: 56,
    updateTime: '2026-08-02',
    views: 890000,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 5,
    title: '命运之线',
    titleKo: '운명의실',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20showing%20a%20couple%20connected%20by%20a%20glowing%20red%20thread%20of%20fate%2C%20dreamy%20atmospheric%20cherry%20blossom%20background%2C%20soft%20pastel%20color%20palette%2C%20emotional%20and%20tender%20expressions%2C%20beautiful%20fantasy%20romance%20webtoon%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    author: '崔智友',
    category: 'romance',
    status: '已完结',
    rating: 9.6,
    description: '两个被命运红线相连的灵魂，在轮回中不断相遇又分离。这一世，他们能否打破宿命的诅咒，谱写属于自己的爱情故事？一段跨越时空的唯美爱情史诗。',
    chapters: 104,
    updateTime: '2026-06-15',
    views: 2100000,
    isHot: false,
    isFeatured: true,
  },
  {
    id: 6,
    title: '拳霸天下',
    titleKo: '권왕천하',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20action%20Korean%20manhwa%20cover%20featuring%20a%20muscular%20fighter%20in%20dynamic%20combat%20pose%20with%20impact%20effects%2C%20intense%20martial%20arts%20tournament%20arena%20background%2C%20dramatic%20red%20and%20orange%20energy%20waves%2C%20fierce%20expression%2C%20clean%20action%20webtoon%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    author: '姜东元',
    category: 'action',
    status: '连载中',
    rating: 9.4,
    description: '地下格斗界的传奇拳手金武烈，为了寻找失踪的师父重出江湖。每一场战斗都是生死较量，他用拳头捍卫正义与信念，成为真正的拳霸。',
    chapters: 62,
    updateTime: '2026-08-01',
    views: 1150000,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 7,
    title: '星之彼方',
    titleKo: '별의저편',
    cover: 'https://readdy.ai/api/search-image?query=A%20dreamy%20Korean%20manhwa%20cover%20showing%20two%20boys%20under%20a%20starry%20night%20sky%2C%20subtle%20romantic%20tension%2C%20beautiful%20celestial%20background%20with%20constellations%2C%20soft%20moonlight%2C%20emotional%20and%20gentle%20expressions%2C%20BL%20genre%20art%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    author: '文在仁',
    category: 'bl',
    status: '连载中',
    rating: 9.2,
    description: '天文社的两个少年在星空下相遇，从最初的互不理解到渐渐产生超越友谊的情感。在追逐星辰的旅程中，他们发现了彼此心中最亮的那颗星。',
    chapters: 38,
    updateTime: '2026-08-04',
    views: 760000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 8,
    title: '恐怖公寓',
    titleKo: '공포아파트',
    cover: 'https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20horror%20manhwa%20cover%20depicting%20a%20dark%20apartment%20building%20with%20one%20ominously%20lit%20window%2C%20eerie%20atmosphere%2C%20ghostly%20figure%20silhouette%2C%20cold%20blue-gray%20color%20scheme%2C%20moonlight%20shadows%2C%20clean%20horror%20webtoon%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    author: '尹钟信',
    category: 'horror',
    status: '连载中',
    rating: 8.9,
    description: '搬进一栋老旧公寓后，女主角发现每晚都会听到奇怪的声音。随着调查深入，她揭开了这栋公寓几十年前发生的恐怖事件的真相，而危险正一步步逼近。',
    chapters: 28,
    updateTime: '2026-08-03',
    views: 540000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 9,
    title: '逆袭之路',
    titleKo: '역습의길',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20showing%20an%20ordinary%20office%20worker%20transforming%20into%20a%20confident%20powerful%20figure%2C%20corporate%20drama%20style%2C%20split%20composition%20showing%20before%20and%20after%2C%20dynamic%20suits%20and%20city%20skyline%20background%2C%20clean%20webtoon%20art&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    author: '赵寅成',
    category: 'drama',
    status: '已完结',
    rating: 9.0,
    description: '被公司无情辞退的中年男人李政洙，凭借坚韧不拔的意志从头开始创业。在商场如战场的残酷竞争中，他用智慧和毅力一步步实现逆袭，成为行业传奇。',
    chapters: 90,
    updateTime: '2026-05-30',
    views: 1350000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 10,
    title: '魔王转生',
    titleKo: '마왕전생',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20powerful%20demon%20lord%20with%20dark%20wings%20and%20glowing%20red%20eyes%20in%20an%20epic%20pose%2C%20magical%20dark%20energy%20surrounding%2C%20gothic%20castle%20background%2C%20intimidating%20yet%20charismatic%20character%20design%2C%20clean%20webtoon%20cover%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    author: '李敏镐',
    category: 'fantasy',
    status: '连载中',
    rating: 9.5,
    description: '最强魔王在神魔大战中被封印千年后，转生到一个普通人类少年身上。带着前世的力量和记忆，他要在新的世界中重新崛起，改写自己的命运。',
    chapters: 55,
    updateTime: '2026-08-04',
    views: 1680000,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 11,
    title: '甜蜜陷阱',
    titleKo: '달콤한함정',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Korean%20manhwa%20cover%20showing%20a%20beautiful%20woman%20and%20handsome%20man%20close%20together%20in%20a%20cafe%20setting%2C%20warm%20cozy%20atmosphere%2C%20soft%20lighting%2C%20flirty%20expressions%2C%20desserts%20and%20coffee%20in%20background%2C%20clean%20romance%20webtoon%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    author: '孙艺珍',
    category: 'romance',
    status: '连载中',
    rating: 9.3,
    description: '甜点师林秀雅在一次意外中救了失忆的财阀继承人，两人在甜品店相处中日久生情。但当男主恢复记忆后，两人的身份差距成为最大的考验。',
    chapters: 42,
    updateTime: '2026-08-02',
    views: 920000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 12,
    title: '猎魔人传说',
    titleKo: '데빌헌터',
    cover: 'https://readdy.ai/api/search-image?query=A%20badass%20Korean%20manhwa%20cover%20featuring%20a%20demon%20hunter%20with%20twin%20pistols%20and%20a%20long%20coat%2C%20action%20pose%2C%20explosive%20background%20with%20fire%20and%20smoke%2C%20supernatural%20elements%2C%20urban%20fantasy%20setting%2C%20cool%20and%20stylish%20character%2C%20clean%20webtoon%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    author: '元斌',
    category: 'action',
    status: '连载中',
    rating: 9.4,
    description: '在现代都市的暗处，恶魔潜伏在人群之中。猎魔人韩志勋继承家族使命，用超凡的战斗技巧和特殊武器猎杀恶魔，维护人间与魔界的平衡。',
    chapters: 66,
    updateTime: '2026-08-03',
    views: 1020000,
    isHot: true,
    isFeatured: true,
  },
  {
    id: 13,
    title: '泪之女王',
    titleKo: '눈물의여왕',
    cover: 'https://readdy.ai/api/search-image?query=A%20poignant%20Korean%20manhwa%20cover%20showing%20a%20queen%20with%20a%20single%20tear%20on%20her%20cheek%2C%20royal%20palace%20background%20in%20soft%20focus%2C%20dramatic%20historical%20costume%2C%20emotional%20and%20heartbreaking%20expression%2C%20subdued%20warm%20color%20palette%2C%20clean%20drama%20webtoon%20style&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    author: '宋慧乔',
    category: 'drama',
    status: '已完结',
    rating: 9.8,
    description: '朝鲜王朝末期，一位被命运捉弄的王妃在权力斗争中失去了一切。她流下的每一滴眼泪都化作力量，最终以智慧和勇气重夺属于自己的一切。',
    chapters: 120,
    updateTime: '2026-04-10',
    views: 3200000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 14,
    title: '爆笑江湖',
    titleKo: '폭소강호',
    cover: 'https://readdy.ai/api/search-image?query=A%20hilarious%20Korean%20manhwa%20cover%20showing%20a%20martial%20arts%20student%20making%20a%20funny%20face%20with%20exaggerated%20comic%20expressions%2C%20traditional%20Chinese-style%20martial%20arts%20school%20background%2C%20colorful%20and%20lively%2C%20comedy%20style%20with%20lots%20of%20visual%20gags%2C%20clean%20webtoon%20art&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    author: '车太贤',
    category: 'comedy',
    status: '连载中',
    rating: 9.0,
    description: '一个天赋异禀但极度懒惰的少年被迫加入武林门派学武，结果闹出无数笑话。从偷懒秘籍到奇葩武功，每一话都能让你笑到肚子疼。',
    chapters: 50,
    updateTime: '2026-08-04',
    views: 710000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 15,
    title: '深渊之谜',
    titleKo: '심연의수수께끼',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20cover%20showing%20a%20detective%20looking%20at%20a%20complex%20crime%20board%20with%20red%20strings%20connecting%20clues%2C%20dark%20office%20setting%2C%20suspenseful%20atmosphere%2C%20dramatic%20lighting%2C%20psychological%20thriller%20vibe%2C%20clean%20webtoon%20style&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    author: '河正宇',
    category: 'thriller',
    status: '连载中',
    rating: 9.6,
    description: '刑警李明宇调查一起看似普通的失踪案，却发现背后牵扯到政商勾结的巨大阴谋。每解开一个谜团，就有更深的黑暗在等待着他。',
    chapters: 40,
    updateTime: '2026-08-01',
    views: 870000,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 16,
    title: '恶灵退散',
    titleKo: '악령퇴치',
    cover: 'https://readdy.ai/api/search-image?query=A%20supernatural%20Korean%20manhwa%20cover%20showing%20a%20shaman%20performing%20an%20exorcism%20ritual%20with%20glowing%20talismans%20and%20spiritual%20energy%2C%20traditional%20Korean%20setting%2C%20ghostly%20entities%2C%20dramatic%20contrast%20between%20light%20and%20dark%2C%20clean%20horror%20webtoon%20style&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    author: '马东锡',
    category: 'horror',
    status: '连载中',
    rating: 9.1,
    description: '拥有通灵能力的少女朴恩熙成为了一名驱魔师，专门处理超自然事件。从学校怪谈到家族诅咒，她用勇气和灵力对抗各种恶灵。',
    chapters: 34,
    updateTime: '2026-08-02',
    views: 630000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 17,
    title: '花间集',
    titleKo: '화간집',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20BL%20Korean%20manhwa%20cover%20showing%20two%20handsome%20young%20men%20in%20traditional%20Korean%20hanbok%20among%20flower%20gardens%2C%20soft%20romantic%20atmosphere%2C%20cherry%20blossoms%2C%20gentle%20touching%20hands%2C%20historical%20setting%2C%20clean%20and%20elegant%20webtoon%20style&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    author: '金秀贤',
    category: 'bl',
    status: '已完结',
    rating: 9.5,
    description: '朝鲜时代的两位贵族青年，在花间相识相知。在那个保守的年代，他们的感情如同隐秘绽放的花朵，美丽却充满荆棘。一段凄美动人的古典爱情。',
    chapters: 78,
    updateTime: '2026-07-01',
    views: 1890000,
    isHot: false,
    isFeatured: true,
  },
  {
    id: 18,
    title: '无敌升级',
    titleKo: '무적레벨업',
    cover: 'https://readdy.ai/api/search-image?query=A%20game-system%20Korean%20manhwa%20cover%20showing%20a%20hunter%20with%20a%20floating%20game%20UI%20interface%20displaying%20stats%20and%20level%2C%20dungeon%20background%2C%20fantasy%20action%20pose%2C%20glowing%20weapon%2C%20energetic%20and%20dynamic%2C%20clean%20webtoon%20style&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    author: '姜栋元',
    category: 'action',
    status: '连载中',
    rating: 9.2,
    description: '地球突然出现地下城，觉醒者金秀赫在濒死之际获得了独一无二的「升级系统」。从最低级猎人到最强觉醒者，他的成长之路充满惊险与热血。',
    chapters: 58,
    updateTime: '2026-08-04',
    views: 1430000,
    isHot: true,
    isFeatured: false,
  },
  {
    id: 19,
    title: '月下美人',
    titleKo: '월하미인',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystical%20Korean%20manhwa%20cover%20featuring%20a%20beautiful%20gumiho%20nine-tailed%20fox%20spirit%20woman%20under%20the%20moonlight%2C%20traditional%20Korean%20aesthetic%2C%20flowing%20silk%20garments%2C%20ethereal%20glowing%20tails%2C%20fantasy%20romance%2C%20clean%20webtoon%20art%20with%20soft%20silver%20and%20white%20tones&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    author: '裴秀智',
    category: 'fantasy',
    status: '连载中',
    rating: 9.4,
    description: '千年九尾狐在月光下化为人形，意外闯入现代人类世界。她与一位普通人类作家的相遇，开启了一段跨越人妖界限的奇幻爱情。',
    chapters: 45,
    updateTime: '2026-08-03',
    views: 1100000,
    isHot: false,
    isFeatured: false,
  },
  {
    id: 20,
    title: '正义的重量',
    titleKo: '정의의무게',
    cover: 'https://readdy.ai/api/search-image?query=A%20courtroom%20drama%20Korean%20manhwa%20cover%20showing%20a%20determined%20female%20lawyer%20in%20court%20attire%20with%20scales%20of%20justice%20imagery%2C%20dramatic%20courtroom%20background%2C%20serious%20and%20powerful%20expression%2C%20clean%20professional%20webtoon%20style&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    author: '全智贤',
    category: 'drama',
    status: '连载中',
    rating: 9.3,
    description: '新人律师崔恩秀接手一桩看似无望的冤案，面对强大的对手和重重阻碍，她凭借对正义的坚持，一步步揭开真相，为无辜者洗清罪名。',
    chapters: 36,
    updateTime: '2026-07-28',
    views: 690000,
    isHot: false,
    isFeatured: false,
  },
];

export const heroBanners = [
  {
    id: 1,
    comicId: 10,
    title: '魔王转生 - 年度最热韩漫',
    subtitle: '最强魔王转生人类少年，逆天改命的史诗旅程',
    bgImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20banner%20showing%20a%20dark%20fantasy%20demon%20lord%20silhouette%20against%20a%20burning%20crimson%20sky%2C%20epic%20scale%2C%20dramatic%20clouds%2C%20powerful%20fantasy%20art%2C%20dark%20toned%20with%20warm%20orange%20and%20red%20highlights%2C%20cinematic%20composition&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 5,
    title: '命运之线 - 完结神作',
    subtitle: '跨越时空的爱情史诗，千万读者的共同选择',
    bgImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20cinematic%20banner%20with%20cherry%20blossoms%20falling%20over%20a%20couple%20silhouette%2C%20soft%20pink%20and%20golden%20hour%20lighting%2C%20dreamy%20atmosphere%2C%20fantasy%20romance%20theme%2C%20cinematic%20wide%20composition%2C%20warm%20and%20ethereal&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 12,
    title: '猎魔人传说 - 燃爆夏日',
    subtitle: '热血战斗 + 都市奇幻，今夏不容错过的韩漫',
    bgImage: 'https://readdy.ai/api/search-image?query=A%20cinematic%20action%20banner%20showing%20a%20stylish%20hunter%20in%20long%20coat%20with%20glowing%20weapons%2C%20urban%20cityscape%20at%20night%2C%20explosive%20effects%2C%20neon%20lights%2C%20dynamic%20action%20composition%2C%20cool%20and%20intense%20atmosphere&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
  },
];